module.exports = __webpack_public_path__ + "VodafoneRgBd_W.5fc2b28751f96d2d9c27.woff";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/fonts/VodafoneRgBd_W.woff
// module id = ../../../../../src/assets/fonts/VodafoneRgBd_W.woff
// module chunks = styles